
const DATE_FORMAT = "YYYY-MM-DD"

export const getSetting = (key, settings) => settings.find(s => s.key == key)
